export default __webpack_public_path__ + "static/media/avatar-placeholder-square.50b1aa6a.svg";